import {
	computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { GetLocalStorage, SetLocalStorage } from '../utilities/cryptography';
import { USER_INFO } from '../constants/storage-keys';
import { navigate } from 'gatsby';
import { CURRENT_PLATFORM } from '../constants/settings';
import { Gender, PAGE_SIZE } from '../constants/options';
import { ProfileTemplate } from '../utilities/profile';
import { GetLangKey, GetUserProfile, Language } from '../utilities/general';

export default class EventStore {

	loading: boolean = false;
	loadingEventInfo: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		makeObservable(this, {
			loading: observable,
			loadingEventInfo: observable,

		});
		this.rootStore = rootStore;
	}

	

	getEventInfoByKey = async (key: string) => {
		this.loadingEventInfo = true;
		try {
			const res = await Axios.get(`/api/Event/Key/${key}`);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loadingEventInfo = false;
		}
	};

	



}